// removed by extract-text-webpack-plugin
module.exports = {"base":"Error_base--3X-zd","base__overlayOpened":"Error_base__overlayOpened--nilEc","baseOverlayOpened":"Error_base__overlayOpened--nilEc","background":"Error_background--3xshU"};


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXLeaderboards/components/Error/Error.scss
// module id = 2478
// module chunks = 11